import React, { lazy, Suspense } from 'react'

// import UploadImageModal from './UploadImageModal';

const LazyModal = lazy(() => import(/* webpackChunkName: "upload-modal" */ './UploadImageModal'))

const UploadImageModal = props => (
  <Suspense fallback={null}>
    <LazyModal {...props} />
  </Suspense>
)

export default UploadImageModal
